import React, {useEffect, useState} from "react";
import PageHeader from "../main/PageHeader";
import useAuth from "../../hooks/useAuth";
import EntityApi from "../../api/EntityApi";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRemove} from "@fortawesome/free-solid-svg-icons";
import ModalConfirm from "../main/ModalConfirm";
import { notification, Button as ButtonAntd } from 'antd';
import {useNavigate} from "react-router-dom";

const AccessUser = ({userId, openForm, reload, openFormAccess}) => {

    const { user, setUser, roles , isAdminOrManagerOrPartner}  = useAuth();
    const navigate = useNavigate();
    const [apiNotification, contextHolder] = notification.useNotification();
    const [items, setItems] = useState([]);
    const [removeId, setRemoveId] = React.useState(0);
    const [isRemoveOpen, setIsRemoveOpen] = useState(false);

    const getList = () => {
        console.log('load');
        EntityApi.getBy('private/access', {
            filter: {
                user_id: userId
            }
        }).then((data) => {
            if (data.status === 'success') {
                setItems(data.content.items);
            }
        });
    }

    const open = (item) => {
        if (isAdminOrManagerOrPartner) {
            openFormAccess(item);
            openForm();
        } else {
            navigate('/cabinet/catalog/course/' + item.entity_id);
        }
    }

    const openModalRemove = (id) => {
        setIsRemoveOpen(true);
        setRemoveId(id);
    }

    const onRemove = () => {
        setIsRemoveOpen(false);
        if (removeId > 0) {
            EntityApi.delete('private/access', removeId).then((data) => {
                if (data.status === EntityApi.STATUS_FAIL) {
                    apiNotification['error']({
                        message: 'Ошибка удаления',
                        description:
                        data.error.messages.join(' '),
                    });
                } else {
                    getList();
                }
            });
        }
        setRemoveId(0);
    }

    useEffect(() => {
        getList();
    }, [reload]);

    return <>
        {contextHolder}
        <div
            className="flex flex-col items-center space-y-4 border-b border-slate-200 p-4 dark:border-navy-500 sm:flex-row sm:justify-between sm:space-y-0 sm:px-5">
            <h2 className="text-lg font-medium tracking-wide text-slate-700 dark:text-navy-100">
                Доступы к курсам
            </h2>
            {
                isAdminOrManagerOrPartner &&
                <button onClick={openForm} className="btn bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                    + Добавить доступ
                </button>
            }
        </div>
        <div className="p-4 sm:p-5">
            <div className="is-scrollbar-hidden min-w-full overflow-x-auto">
                <table className="is-hoverable w-full text-left">
                    <thead>
                    <tr>
                        <th className={"whitespace-nowrap rounded-l-lg bg-slate-200 px-3 py-3 font-semibold text-slate-800 dark:bg-navy-800 dark:text-navy-100 lg:px-5"}>
                            Курс
                        </th>
                        <th className={"whitespace-nowrap mob-hidden bg-slate-200 px-4 py-3 font-semibold  text-slate-800 dark:bg-navy-800 dark:text-navy-100 lg:px-5"}>
                            Сроки доступа
                        </th>
                        <th className={"whitespace-nowrap mob-hidden rounded-r-lg bg-slate-200 px-3 py-3 font-semibold  text-slate-800 dark:bg-navy-800 dark:text-navy-100 lg:px-5"}>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        items && items.map((item) =>
                            <tr key={item.id} className="cursor-pointer border-y border-transparent border-b-slate-200 dark:border-b-navy-500">
                                <td className={'desktop-hidden'}>
                                    <div onClick={() => open(item)} className={'pt-2'} style={{
                                        width: '300px',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}>{item.title}</div>
                                    <div onClick={() => open(item)} className={'flex desktop-hidden pt-2'}>
                                        <span className={'font-bold pr-2'}>Доступ: </span>
                                        {
                                            item.date_from && <div className={'mr-2'}>от {item.date_from}</div>
                                        }
                                        {
                                            item.date_to ? <div>до {item.date_to} </div> : <div>Бессрочно</div>
                                        }
                                    </div>
                                    <div className={'desktop-hidden pt-2 pb-2'}>
                                        {
                                            isAdminOrManagerOrPartner &&
                                            <ButtonAntd onClick={() => openModalRemove(item.id)}>
                                                <FontAwesomeIcon className={'text-error'} icon={faRemove} /> Удалить доступ
                                            </ButtonAntd>
                                        }
                                    </div>
                                </td>
                                <td onClick={() => open(item)}
                                    className="whitespace-nowrap mob-hidden px-4 py-3 sm:px-5">
                                    <div style={{
                                        width: '300px',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}>{item.title}</div>
                                </td>
                                <td onClick={() => open(item)}
                                    className="whitespace-nowrap mob-hidden px-4 py-3 sm:px-5">
                                    <div className={'flex'}>
                                        {
                                            item.date_from && <div className={'mr-2'}>от {item.date_from}</div>
                                        }
                                        {
                                            item.date_to ? <div>до {item.date_to} </div> : <div>Бессрочно</div>
                                        }
                                    </div>
                                </td>
                                <td className="whitespace-nowrap mob-hidden px-4 py-3 sm:px-5">
                                    {
                                        (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) &&
                                        <button onClick={() => openModalRemove(item.id)} className="btn h-8 w-8 p-0 text-error hover:bg-error/20 focus:bg-error/20 active:bg-error/25">
                                            <FontAwesomeIcon icon={faRemove} />
                                        </button>
                                    }
                                </td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </div>
        </div>
        <ModalConfirm title={'Удаление доступа'} text={'Вы действительно хотите удалить доступ?'} cancelText={"Отменить"} confirmText={"Удалить"} onConfirm={onRemove}  isOpen={isRemoveOpen} onClose={() => setIsRemoveOpen(false)}/>

    </>
}

export default AccessUser;
